import { ifNotProp } from 'src/shared/styled-utils/ifNotProp';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';

interface IContainerProps {
  fluid?: boolean;
  noPadding?: boolean;
  noMargin?: boolean;
  fullWidth?: boolean;
}

/**
 * Component for minimally replacing bootstrap container classes
 * @param {IContainerProps} props
 */
export const Container = styled.div<IContainerProps>`
  ${ifProp(
    'fullWidth',
    css`
      width: 100%;
    `
  )}
  ${ifNotProp(
    'noPadding',
    css`
      padding-right: 15px;
      padding-left: 15px;
    `
  )}
  ${ifNotProp(
    'noMargin',
    css`
      margin-right: auto;
      margin-left: auto;
    `
  )}
  ${ifNotProp(
    'fluid',
    css`
      @media (min-width: 768px) {
        width: 750px;
      }
      @media (min-width: 992px) {
        width: 970px;
      }
      @media (min-width: 1200px) {
        width: 1170px;
      }
    `
  )}

  // clearfix
  :after {
    content: '.';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
`;
